export default function delegateEventListener( eventName, selector, callback ) {
	document.addEventListener( eventName, event => {
		let trigger = event.target;
		if ( ! trigger.matches( selector ) ) {
			trigger = trigger.closest( selector );
		}

		if ( ! trigger ) {
			return;
		}

		callback( event, trigger );
	} );
}
